import React from "react";
import { To, NavLink } from "react-router-dom";
import { Icon } from "../icons";
import { IconProps } from "../../models/icon";
import styles from "./Navbar.module.scss";

interface Props {
  to: To;
  text: string;
  icon?: IconProps;
}

const NavbarLinkItem = ({ to, text, icon }: Props) => {
  return (
    <NavLink to={to} className={({ isActive }) => (isActive ? styles.active : "")}>
      {icon && <Icon {...icon} height={16} width={16} />}
      <span>{text}</span>
    </NavLink>
  );
};

export default NavbarLinkItem;
